import { render, staticRenderFns } from "./BaseColorPicker.vue?vue&type=template&id=82ae8666&"
import script from "./BaseColorPicker.vue?vue&type=script&lang=js&"
export * from "./BaseColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./BaseColorPicker.vue?vue&type=style&index=0&id=82ae8666&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82ae8666')) {
      api.createRecord('82ae8666', component.options)
    } else {
      api.reload('82ae8666', component.options)
    }
    module.hot.accept("./BaseColorPicker.vue?vue&type=template&id=82ae8666&", function () {
      api.rerender('82ae8666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseColorPicker.vue"
export default component.exports